export const getAmplitudeDisplayedCtaText = (ctaText: string): string => ctaText.toLocaleUpperCase("pl-PL");
export const getAmplitudeDisplayedCtaText = (ctaText: string): string => ctaText.toLocaleUpperCase("pl-PL");
